export const ShopSlug = 'shop';

export function getShopUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${ShopSlug}`;
}

export function getSubDealerShopUrl(parentDealerSlug: string, subDealerSlug: string): string {
    return `/${parentDealerSlug}/${subDealerSlug}/${ShopSlug}`;
}
